import FormValidations from 'data/FormValidations';
import {
  emptyValidation,
  firstNameValidation,
  lastNameValidation,
} from './constants';

export const hasErrors = (form, translations) => {
  const errors = {};
  Object.assign(
    errors,
    new FormValidations(form.firstname, 'firstname')
      .validateMinLongitude(1, emptyValidation(translations))
      .validateNameFormat(firstNameValidation(translations))
      .getErrors(),
  );

  Object.assign(
    errors,
    new FormValidations(form.lastname, 'lastname')
      .validateMinLongitude(1, emptyValidation(translations))
      .validateNameFormat(lastNameValidation(translations))
      .getErrors(),
  );

  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
};
